import { onBeforeUnmount } from "vue";

export function usePolling() {
  let timer = null;
  let controller = null;
  function stop() { if (timer) clearTimeout(timer); timer = null; controller?.abort(); controller = null; }
  async function start(request, { interval = 1200, maxAttempts = 300, onResult } = {}) {
    stop();
    const activeController = new AbortController();
    controller = activeController;
    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      const result = await request({ signal: activeController.signal });
      if (activeController.signal.aborted || controller !== activeController) {
        throw activeController.signal.reason || new DOMException("Aborted", "AbortError");
      }
      if (result?.state !== "running") {
        onResult?.(result);
        if (controller === activeController) stop();
        return result;
      }
      await new Promise((resolve, reject) => {
        const abort = () => {
          clearTimeout(timer);
          reject(activeController.signal.reason || new DOMException("Aborted", "AbortError"));
        };
        timer = setTimeout(() => {
          activeController.signal.removeEventListener("abort", abort);
          resolve();
        }, interval);
        activeController.signal.addEventListener("abort", abort, { once: true });
      });
    }
    if (controller === activeController) stop();
    throw new Error("The background job took too long.");
  }
  onBeforeUnmount(stop);
  return { start, stop };
}
